import type { QueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { ApiCallError } from "web_myplann/Infrastructure/Api/ApiUtils";

export const invalidatePortfolioOnForbidden = (
	queryClient: QueryClient,
	error: Error,
) => {
	if (error instanceof ApiCallError && error.data.status === 403) {
		queryClient.invalidateQueries({ queryKey: PortfolioKeys.all });
	}
};
